// --- Common ---

// Types
export type { ListingsAPIErrorResponseBody } from './common/types/ListingsAPIErrorResponseBody';
export type {
  ListingsAPIAndFilter,
  IFilter,
  ListingsAPIOrFilter,
  IRangeFilter,
  ITextFilter,
  INegatedFilter,
  IComparisonFilter,
} from './common/types/ListingsAPIFilter';
export {
  ListingsRequestAndFilterBuilder,
  ListingsRequestComparisonFilterBuilder,
  ListingsRequestOrFilterBuilder,
  ListingsRequestRangeFilterBuilder,
  ListingsRequestTextFilterBuilder,
} from './common/builders/ListingsRequestFilterBuilder';

// --- Listings ---

// Functions
export { fetchListingsData } from './listings/fetchListingsData';

// Types
export type {
  ListingsAPIResponseBody,
  ListingsAPIResponseDelivery,
  ListingsAPIResponseDeliveryType,
  ListingsAPIResponseFacet,
  ListingsAPIResponsePagination,
  ListingsAPIResponseRatings,
  ListingsAPIResponseProduct,
  ListingsAPIResponsePartner,
  ListingsAPIResponseNumericAttribute,
  ListingsAPIResponseNumericFacetValue,
  ListingsAPIResponseTextAttribute,
  ListingsAPIResponseTextFacetValue,
} from './listings/types/ListingsAPIResponseBody';
export type {
  ListingsAPIDeliveryZone,
  ListingsAPIRequestBody,
} from './listings/types/ListingsAPIRequestBody';

// Fixtures
export { listingsResponse500 } from './listings/fixtures/listingsResponse500';
export { listingsResponseBody } from './listings/fixtures/listingsResponseBody';

// Builders
export {
  buildListingsProduct,
  buildListingsPartner,
  buildListingsRatings,
} from './listings/builders/buildListingsProduct';
export { ListingsRequestBuilder } from './listings/builders/ListingsRequestBuilder';
export {
  ListingsRequestFacetBuilder,
  ListingsRequestFacetIntervalBuilder,
} from './listings/builders/ListingsRequestFacetBuilder';

// --- Recommendations ---

// Functions
export { fetchRecommendationsData } from './recommendations/fetchRecommendationsData';
export { isHighlyRated, isTopBrand } from './recommendations/attributes';

// Types
export type { RecommendationsResponseBody } from './recommendations/types/RecommendationsResponseBody';
export type {
  RecommendationsRequestBody,
  RecommendationsRequestHeaders,
} from './recommendations/types/RecommendationsRequestBody';
export type { RecommendationsServingConfig } from './recommendations/types/RecommendationsServingConfig';
export type { FetchRecommendationsDataArgs } from './recommendations/fetchRecommendationsData';
/* `DeliveryType` is deliberately not re-exported. It is the same union as
   `ListingsAPIResponseDeliveryType` above under a much vaguer name, so having both
   at the package root invites a consumer to import whichever autocomplete offers
   first. Nothing needs it by name: `delivery.type` is typed through `IDelivery`.
   If a consumer ever does, give it a name that says which endpoint it describes. */
export type {
  IDelivery,
  Image,
  IProductBasic,
  IProductDeliveryInfo,
  IPrice,
} from './recommendations/types/listings-api/Products';
export type { IRecommendationsAttributes } from './recommendations/attributes';
export type { EventType } from './recommendations/types/RecommendationsRequestBody';

// Fixtures
export {
  recommendationsResponseBody,
  recommendationsResponseBodySaleAUD,
} from './recommendations/fixtures/recommendationsResponseBody';

// Builders
export { RecommendationsRequestBuilder } from './recommendations/builders/RecommendationsRequestBuilder';
